import React from "react";
import ReactDOM from "react-dom/client";
// import { useState } from "react";
import "./index.css";
import App from "./App";
import Themes from "./pages/Themes/Themes";
import ComingSoon from "./pages/ComingSoon/ComingSoon";
import CommitteePage from "./pages/Committee/Committee";
import FeeDetails from "./pages/FeeDetails/FeeDetails";
import Contact from "./pages/Contact/Contact";
import Sponsors from "./pages/Sponsors/Sponsors.js";
import AboutIITG from "./pages/AboutIITG/AboutIITG";
import AboutIITR from "./pages/AboutIITR/AboutIITR";
import AboutISET from "./pages/AboutISET/AboutISET";
import KeyDates from "./pages/KeyDates/KeyDates";
import PanelSpeakers from "./pages/PanelSpeakers/PanelSpeaker";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import SciCommittee from "./pages/SciCommittee/SciCommittee.js";
import Registration from "./pages/Registration/Registration.js";
import ParentComponent from "./pages/AdminPanel/ParentComponent";
import ThemeSpeakers from "./pages/ThemeSpeakers/ThemeSpeakers.js";
import AdvisoryCommittee from "./pages/AdvisoryCommittee/AdvisoryCommittee.js";
import InHouseCommittee from "./pages/InHouseCommittee/HouseCommittee.js";
import HostelAccomodationCharges from "./pages/HostelAccomodationCharges/HostelAccomodationCharges.js";
// import AdminRegistration from "./pages/AdminPanel/AdminRegisteration";
// import { set } from "mongoose";
// import MainAdminPanel from "./pages/AdminPanel/MainAdminPanel";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/8icragee">
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/themes" element={<Themes />} />
      <Route path="/cs" element={<ComingSoon />} />
      <Route path="/committee" element={<CommitteePage />} />
      <Route path="/fee" element={<FeeDetails />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/sponsors" element={<Sponsors />} />
      <Route path="/iitg" element={<AboutIITG />} />
      <Route path="/iset" element={<AboutISET />} />
      <Route path="/iitr" element={<AboutIITR />} />
      <Route path="/keydates" element={<KeyDates />} />
      <Route path="/panelSpeakers" element={<PanelSpeakers />} />
      <Route path="/themeSpeakers" element={<ThemeSpeakers />} />
      <Route path="/sciCommittee" element={<SciCommittee />} />
      <Route path="/advCommittee" element={<AdvisoryCommittee />} />
      <Route path="/inHouseCommittee" element={<InHouseCommittee />} />
      <Route path="/registration" element={<Registration />} />
      <Route
        path="/hostelAccomodationCharges"
        element={<HostelAccomodationCharges />}
      />
      <Route path="/*" element={<ParentComponent />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
